import { IAttrValue } from "@multiweb/types/contracts";
import { PromiseUtils } from "Global/Base/Promises/PromiseUtils";
import { OWObject } from "OW.Remoting/Remoting/DataTypes/OWObject";
import { GenericControl } from "UI/UI.BaseControls/GenericControl";
import { IEditItemTemplateMasterRef } from "UI/UI.Controls/DataGridSubcontrols/Templates/ITemplate";
import { AttrValueReader } from "../../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { EditItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/EditItemTemplate";
import { ElementUtils } from "../../../../../../UI.ElementarControls/Helpers/ElementUtils";
import { TextLOVEdit } from "../../../Controls/TextLOVEdit";
import { IMasterObjectRequestDetail } from "../LOVColumn";
import { TextLovColumn } from "../TextLOVColumn";

export class TextLOVEditTemplate extends EditItemTemplate implements IEditItemTemplateMasterRef {
    //#region Methods
    public override updateData(dataSet: IAttrValue[], item: HTMLElement): void {
        const data = AttrValueReader.read(this._getDataFromSet(dataSet));

        const currentTextLOVEdit = item as TextLOVEdit;
        // musí se odregistrovat listener a změnit hodnota, aby nedošlo k znovuvyvolání události "change"
        const changeListeners: Array<(e: Event) => void> = currentTextLOVEdit.getEventListeners("change");
        currentTextLOVEdit.unregisterEventListener("change");
        currentTextLOVEdit.value = data;
        for (const l of changeListeners) {
            currentTextLOVEdit.registerEventListener("change", l);
        }
    }

    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const editableControl = new TextLOVEdit();

        const lovColumn = this.parentColumn as TextLovColumn;
        editableControl.attrName = this.parentColumn.attrName;
        editableControl.setInnerAttribute("data-ShowAttr", lovColumn.showAttr);
        editableControl.setInnerAttribute("data-AttrName", this.parentColumn.attrName);
        editableControl.setInnerAttribute("data-EditWindow", lovColumn.editWindow);

        if (lovColumn.condition)
            editableControl.setInnerAttribute("data-Condition", lovColumn.condition);
        if (lovColumn.conditionParamsAttrs)
            editableControl.setInnerAttribute("data-ConditionParams", lovColumn.conditionParamsAttrs);
        if (lovColumn.additionalAttrs)
            editableControl.setInnerAttribute("data-AdditionalAttrs", lovColumn.additionalAttrs);
        if (lovColumn.showAdditionalAttrs)
            editableControl.setInnerAttribute("data-ShowAdditionalAttrs", lovColumn.showAdditionalAttrs);

        editableControl.renderLov();

        editableControl.textLovEdit.enabled = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva

        editableControl.textLovEdit.enabledVisual = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva

        // v dalším ticku, až bude element v DOMu, aby šlo hledat rodiče
        PromiseUtils.delay(0).then(() => {
            const id = GenericControl.findParent(editableControl as HTMLElement, (el) => el.classList.contains("DataRow")).getAttribute("datakey");
            ElementUtils.callEvent(column as HTMLElement, "masterObjectRequest", {
                control: editableControl,
                objectId: id != null ? id : "",
                data: AttrValueReader.read(this._getDataFromSet(dataSet)),
            } as IMasterObjectRequestDetail, true, true);
        });

        // listenery je potřeba vždy po přidání do DOMu znovu zaregistrovat
        editableControl.afterAttach(() => {
            editableControl.registerEventListener("change", (e) => {
                e.stopPropagation();
                ElementUtils.callEvent(parentItem, "valuechanged", { value: editableControl.value, column: this.parentColumn });
            });
        });
        return { element: editableControl as HTMLElement, validatableControl: editableControl };
    }

    /**
     * Aktualizuje instanci objektu
     * @param obj nový objekt
     * @param item HTML element reprentující buňku sloupce
     */
    public setInstance(obj: OWObject, item: HTMLElement): void {
        const currentTextLOVEdit = item as TextLOVEdit;
        currentTextLOVEdit.actualObject = obj;
    }
    //#endregion Methods
}
